import React, { Component } from 'react';
import { Form, Grid, Input, Modal, Panel, DatePicker, Confirm } from 'framework-ui-components';
import { Button } from 'framework-ui-components/Components/V2';
import * as webapi from 'apis/assegnoNucleoFamiliareApi';
import { SnackbarWrapper } from 'framework-ui-components/Components/Snackbar';
import { codiceFiscaleValido } from 'framework-ui-components/Components/Validation';
import { StatoDichiarazione } from 'enums';

class ModaleCreazioneVariazione extends Component {

  constructor(props) {
    super(props);
    this.state = {
      commit: {
        label: 'Crea',
      },
      codiceFiscale: (props.modaleCreazioneContext && props.modaleCreazioneContext.codiceFiscale) || '',
      cognome: (props.modaleCreazioneContext && props.modaleCreazioneContext.cognome) || '',
      nome: (props.modaleCreazioneContext && props.modaleCreazioneContext.nome) || '',
      dataInizio: null,
      dataFine: new Date('06/30/' + (props.annoCampagna + 1)),
      idAnagrafica: null,
    };
  }

  componentDidUpdate(propsPrecedenti, statePrecedente, snapshot) {
    const { codiceUfficio, annoCampagna } = this.props;
    const { codiceFiscale, dataInizio } = this.state;
    if ((codiceFiscale && codiceFiscale != statePrecedente.codiceFiscale ||
         dataInizio && dataInizio != statePrecedente.dataInizio) &&
        codiceFiscaleValido(codiceFiscale)) {
      this.verificaDichiarazioneCreabile(codiceFiscale, codiceUfficio, annoCampagna);
    }
  }

  verificaDichiarazioneCreabile(codiceFiscale = '', codiceUfficio, anno) {
    this.setState({ working: true });
    webapi.verificaVariazioneCreabile({ codiceFiscale, codiceUfficio, anno })
      .then(result => this.elaboraRispostaVerificaCreabilita(result || {}))
      .catch((ex) => {
        SnackbarWrapper.notifyError(ex.message);
        this.setState({ working: false });
      });
  }

  avviaComando() {
    const { idAssegnoNucleoFamiliare, creabile, modificabile, stato, cognome, nome, dataInizio, esisteReiezione } = this.state;
    const { apriDichiarazione, avviaImpostaStatoInLavorazione, chiudi, creaDichiarazioneVariazione, modificaDichiarazioneVariazione } = this.props;

    if (esisteReiezione && creabile) {
      return chiudi();
    }

    if (creabile) {
      creaDichiarazioneVariazione(this.state)
        .then((res) => {
          if (res.Success) {
            apriDichiarazione(res.Response.IdAssegnoNucleoFamiliare, true);
          } else {
            this.setState({ messaggi: res.DetectedProblems, working: false });
          }
        })
        .catch(ex => this.setState({ messaggi: [ex.message], working: false }));
    } else if (stato != StatoDichiarazione.InLavorazione) {
      Confirm('Cambio stato "In lavorazione"', `Vuoi spostare la dichiarazione di ${cognome} ${nome} nello stato "In lavorazione" ?`, 'warning')
        .then(() => avviaImpostaStatoInLavorazione([idAssegnoNucleoFamiliare]))
        .then(() => modificaDichiarazioneVariazione(idAssegnoNucleoFamiliare, dataInizio))
        .then(() => apriDichiarazione(idAssegnoNucleoFamiliare, true))
        .catch(() => this.aggiornaStato({ working: false }));
    } else if (modificabile) {
      modificaDichiarazioneVariazione(idAssegnoNucleoFamiliare, dataInizio)
        .then(() => apriDichiarazione(idAssegnoNucleoFamiliare, modificabile));
      this.setState({ working: false });
    } else {
      apriDichiarazione(idAssegnoNucleoFamiliare, false);
    }
  }

  elaboraRispostaVerificaCreabilita({ DetectedProblems, Response }) {
    const { cognome, nome } = this.state;

    if (!Response) {
      this.setState({
        messaggi: DetectedProblems,
        creabile: false,
        codiceFiscale: null,
        working: false,
      });
    } else {
      if (DetectedProblems.length == 0) {
        if (Response.Modificabile || Response.IdAssegnoNucleoFamiliare) {
          const descrizioneStato = Response.Stato == StatoDichiarazione.InLavorazione && Response.TotaleErrori > 0 ? 'Errata' : StatoDichiarazione.stringify(Response.Stato);
          DetectedProblems.push(`Esiste una variazione per ${cognome} ${nome} in stato "${descrizioneStato}". Vuoi ${Response.Modificabile ? 'modificarla' : 'visualizzarla'} ?`);
        } else if (!Response.Creabile) {
          DetectedProblems.push(`Non è possibile creare una dichiarazione per ${cognome} ${nome}`);
        }
      }
      this.setState({
        idAnagrafica: Response.IdAnagrafica,
        cognome: Response.Cognome,
        nome: Response.Nome,
        messaggi: DetectedProblems,
        creabile: Response.Creabile,
        modificabile: Response.Modificabile,
        stato: Response.Stato,
        totaleErrori: Response.TotaleErrori,
        idAssegnoNucleoFamiliare: Response.IdAssegnoNucleoFamiliare,
        commit: {
          disabled: !Response.Creabile && !Response.Modificabile && !Response.IdAssegnoNucleoFamiliare,
          label: (Response.Modificabile && Response.Stato == StatoDichiarazione.InLavorazione) ? 'Modifica' :
            (Response.IdAssegnoNucleoFamiliare ? 'Visualizza' :
              (Response.EsisteReiezione ? 'Ho Capito' : 'Crea')),
        },
        working: false,
      });
    }
  }

  handleFormChange(x) {
    this.setState(x);
  }

  handleClickCrea() {
    if (this.formValido()) {
      this.setState({ working: true });
      this.avviaComando();
    }
  }

  formValido(formErrors) {
    const { FormErrors } = this.state;
    return !(Object.values(FormErrors).some(ff => ff && ff.length > 0));
  }

  render() {
    const { annoCampagna, chiudi } = this.props;
    const { messaggi, working, idAnagrafica, commit, esisteReiezione, creabile,
      dataInizio,
      dataFine,
      codiceFiscale,
      cognome,
      nome,
    } = this.state;

    const formCompleto = nome && cognome && dataInizio;

    const disabilitatoCrea = (!codiceFiscaleValido(codiceFiscale) || !dataInizio || !cognome || !nome);

    return (
      <Modal show onClose={() => chiudi()} loading={working}>
        <Modal.Header>
          Crea Assegno nucleo familiare variazione {annoCampagna}
        </Modal.Header>
        <Modal.Body>
          <Form onChange={x => this.handleFormChange(x)} stato={this.state}>
            <Grid fluid>
              <Grid.Row>
                <Grid.Col md="6">
                                <DatePicker title="Inizio validità" date={dataInizio} futureDate name="dataInizio" validations={['required']} />
                </Grid.Col>
                <Grid.Col md="6">
                                <DatePicker disabled date={dataFine} futureDate title="Fine validità" />
                </Grid.Col>
              </Grid.Row>
              <Grid.Row>
                <Grid.Col md="6">
                  <Input title="Codice fiscale" name="codiceFiscale" validations={['required', 'CodiceFiscaleAlfaNumerico']} maxLength="16" upperCase />
                </Grid.Col>
              </Grid.Row>
              <Grid.Row>
                <Grid.Col md="6">
                  <Input title="Cognome" name="cognome" validations={['required']} disabled={idAnagrafica} upperCase />
                </Grid.Col>
                <Grid.Col md="6">
                  <Input title="Nome" name="nome" validations={['required']} disabled={idAnagrafica} upperCase />
                </Grid.Col>
              </Grid.Row>
              <Grid.Row>
                <Grid.Col md="12">
                  {
                    esisteReiezione && creabile && <Panel alert> Esiste una dichiarazione in stato "Reiezione INPS".<br />
                      N.B. per generare un nuovo modello Ordinario per questo nominativo utilizza la funzione "Duplica in un nuovo Anf", presente nel menu di rigo.
                    </Panel>
                  }
                  {
                    messaggi && messaggi.length == 1 && <Panel error>
                      {messaggi[0]}
                    </Panel>
                  }
                  {
                    messaggi && messaggi.length == 2 && <Panel error>
                      {messaggi[0]}<br />{messaggi[1]}
                    </Panel>
                  }

                  {
                    messaggi && messaggi.length == 3 && <Panel error>
                      {messaggi[0]}<br />{messaggi[1]}<br />{messaggi[2]}
                    </Panel>
                  }

                  {
                    messaggi && messaggi.length > 3 && <Panel error>
                      {messaggi[0]}<br />{messaggi[1]}<br />{messaggi[2]}<br />{messaggi[4]}
                    </Panel>
                  }
                </Grid.Col>
              </Grid.Row>
            </Grid>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button emphasis={Button.Emphasis.HIGH} onClick={() => chiudi()}>Annulla</Button>
          <Button emphasis={Button.Emphasis.HIGH} primary disabled={disabilitatoCrea} onClick={() => this.handleClickCrea()}>{formCompleto ? commit.label : 'Crea'}</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ModaleCreazioneVariazione;
